import gql from 'graphql-tag';
import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {withApollo} from 'react-apollo';
import {Col, Container, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {PulseLoader} from 'react-spinners';
import logoCleanbill from '../../common/assets/img/logo-cleanbill-blanc.png';
import Error from '../../common/components/Error/Error';
import {Card, CardGroup, CardText, CardTitle} from '../../common/look/ui-bootstrap/components';

const GRAPHQL_MUTATION_ACTIVATE_ACCOUNT = gql`
    mutation activateAccount($token: String!) {
        activateAccount(token: $token){
            id
        }
    }
`;


class ActivateUser extends Component {
  state = {
    confirmed: false,
    error: null,
    loading: true,
  };

  componentDidMount() {
    const {match, client} = this.props;
    const token = match.params.token;
    client
      .mutate({mutation: GRAPHQL_MUTATION_ACTIVATE_ACCOUNT, variables: {token}})
      .then(() => {
        this.setConfirmed(true);
        this.setLoading(false);
      })
      .catch(error => {
        this.setError(error);
        this.setLoading(false);
      });
  }

  setConfirmed = value => {
    this.setState({confirmed: value});
  };

  setError = error => {
    this.setState({error});
  };

  setLoading = loading => {
    this.setState({loading});
  };

  render() {
    const {t} = this.props;
    const {confirmed, error, loading} = this.state;
    return (

      <div className="public-layout">
        <div className="login-layout">
          <Container className="container-full login-container">
            <Row>
              <Col xs={{span: 6, offset: 3}} lg={{span: 4, offset: 4}} className="cleanbill-login-col">
                <img src={logoCleanbill} className="cleanbill-white-logo" alt="logo" />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={{span: 8, offset: 2}} lg={{span: 6, offset: 3}} className="cleanbill-login-col">
                <Card className="confirm-email">
                  <CardGroup style={{textAlign: 'center'}}>
                    {loading && <PulseLoader loading={loading}/>}
                    {error && (
                      <Error error={error} />
                    )}
                    {confirmed && (
                      <>
                        <CardTitle>{t('reg.successRegTitle')}</CardTitle>
                        <CardText>{t('reg.successRegUserBody')}</CardText>
                      </>
                    )}
                  </CardGroup>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}

ActivateUser.propTypes = {
  match: PropTypes.func.isRequired,
  client: PropTypes.object.isRequired,
};

export default compose(
  withApollo,
  withTranslation('login'),
)(ActivateUser);
